import React from "react";
import { useState } from "react";
import teamData from "../Components/Data/dataTeam";
import TeamCard from "../Components/team/TeamCard";

function Team() {
  const [openCardId, setOpenCardId] = useState(null); // to make sure only one card is open at once

  return (
    <>
      <h1 className="seo-only">Meet the Final Version 2 Team</h1>
      <h2 className="seo-only">Learn more about the team behind Final Version 2.</h2>
      <div className='team-page'>
        <div className='team-page-center'>
          <div className='team-details-top'>

            <div className='team-list-title'> The team </div>
            <div className='team-list-details'>
              {teamData.map((item) => (
                <TeamCard
                  key={item.id}
                  image={item.image}
                  name={item.name}
                  jobTitle={item.jobTitle}
                  desc={item.description}
                  linkedin={item.linkedin}
                  answer1={item.answer1}
                  answer2={item.answer2}
                  answer3={item.answer3}
                  answer4={item.answer4}
                  isVisible={openCardId === item.id}
                  onToggle={() =>
                    setOpenCardId((prevId) => (prevId === item.id ? null : item.id))
                  }
                />
              ))}
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
export default Team;
